/**
 * Pages a signed-in user can reach without their company and phone: the
 * screen that asks for them, and the ones that come before it or get them out.
 */
const EXEMPT = new Set([
  "/complete-profile",
  "/verify-email",
  "/login",
  "/signup",
  "/logout",
  "/forgot-password",
  "/link-account",
]);

export type ProfileStatus = "loading" | "complete" | "incomplete";

/**
 * Where to send a signed-in user whose profile is missing company or phone,
 * or null to let the page render. The current page rides along as `return`,
 * so saving the profile lands them back where they were headed.
 */
export function profileGateRedirect(pathname: string, search: string, status: ProfileStatus): string | null {
  if (status !== "incomplete" || EXEMPT.has(pathname)) return null;
  const here = pathname + search;
  return here === "/home" || here === "/"
    ? "/complete-profile"
    : `/complete-profile?return=${encodeURIComponent(here)}`;
}

/** True when the page has to wait for the profile before rendering. */
export function profileGateWaits(pathname: string, status: ProfileStatus): boolean {
  return status === "loading" && !EXEMPT.has(pathname);
}
